"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.router = void 0;
const effects_1 = require("redux-saga/effects");
const errors_1 = require("src/utils/errors");
const api_client_1 = require("src/redux/store/api-client");
const actions_1 = require("src/redux/actions");
const selectors_1 = require("./selectors");
// eslint-disable-next-line max-statements, complexity
function* ensureInterviewId() {
    const interviewId = yield (0, effects_1.select)(selectors_1.getInterviewId);
    if (interviewId) {
        return;
    }
    const location = yield (0, effects_1.select)(selectors_1.getLocation);
    const slug = yield (0, effects_1.select)(selectors_1.getSlug);
    const { respReuse, redirects, pageOrder, revisionId, groupChildren, questionOptions } = yield (0, effects_1.select)(selectors_1.getSurveyConfig);
    const apiClient = (0, api_client_1.getClient)(location);
    try {
        const { status, data } = yield apiClient.startInterview({
            slug,
            respReuse,
            redirects,
            pageOrder,
            revisionId,
            groupChildren,
            questionOptions,
            queryString: location.search.substring(1)
        });
        const { _ivid, _uid } = data || {};
        if (status < 300 && _ivid) {
            yield (0, effects_1.put)((0, actions_1.startInterview)({ _ivid, _uid }));
        }
        else {
            throw new Error('Could not receive interviewId');
        }
    }
    catch (err) {
        console.error(err);
        (0, errors_1.sendError)(err);
    }
}
// eslint-disable-next-line import/prefer-default-export
function* router() {
    yield (0, effects_1.takeEvery)('SURVEY_RESTORED_FROM_PRELOADED_STATE', ensureInterviewId);
}
exports.router = router;
